import { formatarMoeda } from '@/shared/utils/numeros';
import { SimuladorFolhaPorFuncao, SimuladorFolhaResumo } from '../simulador-folha.types';

interface Props {
  dados: SimuladorFolhaPorFuncao[];
  resumo?: SimuladorFolhaResumo;
  tableId?: string;
}

export function TabelaPorFuncao({ dados, resumo, tableId = 'tabela-simulador-funcao' }: Props) {
  const totais = resumo ?? {
    quantidadeServidores: dados.reduce((acc, item) => acc + item.quantidade, 0),
    totalAtual: dados.reduce((acc, item) => acc + item.totalAtual, 0),
    totalProjetado: dados.reduce((acc, item) => acc + item.totalProjetado, 0),
    diferenca: dados.reduce((acc, item) => acc + item.diferenca, 0),
  };

  return (
    <div className="table-responsive">
      <table id={tableId} className="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th>Função (cargo)</th>
            <th className="text-center">Qtd.</th>
            <th className="text-end">Atual</th>
            <th className="text-end">Projetado</th>
            <th className="text-end">Diferença</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((item) => (
            <tr key={item.funcaoId}>
              <td>{item.funcaoNome}</td>
              <td className="text-center">{item.quantidade}</td>
              <td className="text-end">{formatarMoeda(item.totalAtual)}</td>
              <td className="text-end">{formatarMoeda(item.totalProjetado)}</td>
              <td className="text-end">{formatarMoeda(item.diferenca)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot className="table-secondary fw-semibold">
          <tr>
            <td>Total</td>
            <td className="text-center">{totais.quantidadeServidores}</td>
            <td className="text-end">{formatarMoeda(totais.totalAtual)}</td>
            <td className="text-end">{formatarMoeda(totais.totalProjetado)}</td>
            <td className="text-end">{formatarMoeda(totais.diferenca)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
